import { useState, useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

const sceneList = [
    {
        name: 'detail.sectionO_3',
        video: ['/video/wave2/pc/section_o_1.webm', '/video/wave2/pc/section_o_1.mp4'],
        webpSrc: require('@publicLocal/wave2/detail/pc/o_1.webp'),
        src: require('@publicLocal/wave2/detail/pc/o_1.jpg'),
    },
    {
        name: 'detail.sectionO_4',
        video: ['/video/wave2/pc/section_o_2.webm', '/video/wave2/pc/section_o_2.mp4'],
        webpSrc: require('@publicLocal/wave2/detail/pc/o_2.webp'),
        src: require('@publicLocal/wave2/detail/pc/o_2.jpg'),
    },
    {
        name: 'detail.sectionO_5',
        video: ['/video/wave2/pc/section_o_3.webm', '/video/wave2/pc/section_o_3.mp4'],
        webpSrc: require('@publicLocal/wave2/detail/pc/o_3.webp'),
        src: require('@publicLocal/wave2/detail/pc/o_3.jpg'),
    },
    {
        name: 'detail.sectionO_6',
        video: ['/video/wave2/pc/section_o_4.webm', '/video/wave2/pc/section_o_4.mp4'],
        webpSrc: require('@publicLocal/wave2/detail/pc/o_4.webp'),
        src: require('@publicLocal/wave2/detail/pc/o_4.jpg'),
    },
];

export default function O() {
    const { useLang } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');
    const [active, setActive] = useState(0);

    const onChangeScene = (index: number) => setActive(index);

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.wave2-detail-O .viewport-wrapper', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.wave2-detail-O .viewport-wrapper',
            triggerHook: 1,
            offset: '10%',
            duration: '20%',
        });
    }, []);

    return (
        <div className={`wave2-detail-O ${css.wave2DetailO}`}>
            <div className="viewport-wrapper">
                <div className="text-wrapper">
                    <p className="title">{t('detail.sectionO_title')}</p>
                    <p className="desc">{t('detail.sectionO_desc')}</p>
                </div>
                <div className="video-wrapper">
                    <div className="left">
                        {sceneList.map((item, i) => {
                            if (i === active) {
                                return (
                                    <div className="img" key={i}>
                                        <NextImage webpSrc={item.webpSrc} src={item.src} alt={t(item.name)} arial-label={t(item.name)} />
                                    </div>
                                );
                            }
                        })}
                    </div>
                    <div className="right">
                        {sceneList.map((item, i) => (
                            <p className={`text ${active === i ? 'active' : ''}`} key={i} onClick={() => onChangeScene(i)}>
                                {t(item.name)}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
